module.exports = __webpack_public_path__ + "62e7e8c1e3668e7e8a3dfd82ab2d9233.svg";